import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useEffect, useState } from "react";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import BoxKit from "@/shared/components/kit/box";
import NorthWestOutlinedIcon from "@mui/icons-material/NorthWestOutlined";
import { Grid } from "@mui/material";
import DonutChart from "@/shared/components/common/donutChart";
import moment from "jalali-moment";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import { fetchListListMerchantName } from "@/api/merchant/request.get";
import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchChartGiftPazirandeBar } from "@/api/merchant/request.post";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
/**
 * TotalSales
 *
 * نمایش مجموع فروش پذیرنده در قالب یک کارت تحلیلی شامل:
 * - نمودار دونات (DonutChart)
 * - بازه زمانی اولین و آخرین تراکنش
 * - خلاصه فروش‌ها و اعتبارها بر اساس داده‌های `dataAssets`
 *
 * این کامپوننت با توجه به اطلاعات ورودی (all یا pazirande) داده‌ها را تجمیع کرده
 * و برای نمایش نمودار، متن و ساختار کارت استفاده می‌کند. همچنین اطلاعات تکمیلی
 * از طریق APIهای مرتبط بازیابی می‌شوند.
 *
 * ویژگی‌ها:
 * - استخراج و تجمیع داده‌های فروش (هدیه، نقدی، IPG، اعتبارات، نقدینگی، ...)
 * - دریافت نام پذیرنده از API و سپس واکشی اطلاعات نمودار اعتبار هدیه
 * - نمایش بازه زمانی تراکنش‌ها با تبدیل تاریخ به قالب جلالی
 * - رندر نمودار دونات جهت نمایش سهم هر دسته مالی
 * - طراحی واکنش‌گرا و سازگار با اندازه‌های مختلف صفحه
 *
 * پارامترها:
 * @param dataAssets داده‌های کامل دارایی/فروش پذیرنده شامل all یا pazirande
 *
 * @returns JSX.Element کارت نمایش مجموع فروش همراه با نمودار و بازه زمانی
 */

const TotalSales = ({ dataAssets }: { dataAssets: any }) => {
  const [newData, setNewData] = useState<any>([]);
  const {data: dataListMerchantName,isFetched,isLoading,refetch,} = useQuery({
    queryKey: ["ListList-data"],
    queryFn: fetchListListMerchantName,
  });

  const [listIncreaseGiftChart, setListIncreaseGiftChart] = useState<any>([]);

  useEffect(() => {
    if (
      dataAssets?.pazirande &&
      Array.isArray(dataAssets.pazirande) &&
      dataAssets.pazirande.length > 0
    ) {
      setNewData([
        dataAssets.pazirande[0].gift,
        dataAssets.pazirande[0].sumCacheInner,
        dataAssets.pazirande[0].sumCreditInner,
        dataAssets.pazirande[0].sumNotReached,
        dataAssets.pazirande[0].sumReached,
        dataAssets.pazirande[0].wallet,
      ]);
    } else if (dataAssets?.all) {
      setNewData([
        dataAssets.all.sumCacheInner,
        dataAssets.all.gift,
        dataAssets.all.sumCreditInner,
        dataAssets.all.sumNotReached,
        dataAssets.all.sumReached,
        +dataAssets.all.wallet,
      ]);
    } else {
      setNewData([]);
    }
  }, [dataAssets]);

  // const { mutate: submitFormGiftPazirandeBar } = useMutation({
  //   mutationFn: (body: any) => fetchChartGiftPazirandeBar(body),
  //   onSuccess: (data: any) => {
  //     setListIncreaseGiftChart(data?.data)
  //   },
  //   onError: (error: AxiosError<{ message: string }>) => {
  //     toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
  //   },
  // });

  useEffect(() => {
    if (dataListMerchantName?.userInfo?.pazirande_number) {
      const requestBody = {
        pazirande_number: dataListMerchantName?.userInfo?.pazirande_number,
      }
      // submitFormGiftPazirandeBar(requestBody)
    }

  }, [dataListMerchantName?.userInfo?.pazirande_number])

  const chart =
    dataAssets?.pazirande &&
      Array.isArray(dataAssets.pazirande) &&
      dataAssets.pazirande.length > 0 ? dataAssets?.pazirande[0]?.chart : dataAssets?.all?.chart;

  const firstDate = chart && chart.length > 0 ? moment(chart[chart.length - 1].date).locale("fa").format("YYYY/MM/DD") : null;
  const lastDate = chart && chart.length > 0 ? moment(chart[0].date).locale("fa").format("YYYY/MM/DD") : "";
  const series = newData;
  const labels = ["اعتبار هدیه","فروش نقدی خارجی","فروش IPG ( انلاین)","اعتبار خارجی","اعتبار داخلی","فروش نقدی داخلی",]
  const colors = ["#FF6384", "#36A2EB", "#FFCE56"];
  return (
    <CardKit sx={{ backgroundColor: "#434343", color: "#fff",  minHeight: { xs: "220px", sm: "260px", md: "278px" }, borderRadius: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", position: "relative", border: "1px solid #333" }}>
      <Grid alignItems={'center'} container spacing={2} sx={{ width: "100%", paddingInline: { xs: "4px", sm: "0" }, }}>
        {/* Header Section */}
        <Grid size={{ xs: 12 }}>
          <StackKit direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" sx={{ width: "100%", gap: { xs: 1, sm: 2 } }}>
            <StackKit direction="row" justifyContent="start" alignItems="center" gap={1}>
              <ShowChartOutlinedIcon fontSize="small" />
              <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "13px", sm: "14px", md: "15px" } }}>
                مجموع فروش
              </TypoGraphyKit>
            </StackKit>
          </StackKit>
        </Grid>

        {/* Date Range Section */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <StackKit direction="row" justifyContent="space-around" alignItems="center" sx={{ width: "100%" }}>
            <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "11px", sm: "12px" } }}>
              از تاریخ
            </TypoGraphyKit>
            <BoxKit sx={{ height: "20px", background: "#1C1C1D", display: "flex", justifyContent: "center", alignItems: "center", paddingInline: "6px", borderRadius: "5px", }}>
              <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "10px", sm: "11px" }, color: "#A4A4A4", }}>
                {toPersianNumber(`${firstDate}`)}
              </TypoGraphyKit>
            </BoxKit>
          </StackKit>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <StackKit direction="row" justifyContent="space-around" alignItems="center" sx={{ width: "100%" }}>
            <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "11px", sm: "12px" } }}>
              تا تاریخ
            </TypoGraphyKit>
            <BoxKit sx={{ height: "20px", background: "#1C1C1D", display: "flex", justifyContent: "center", alignItems: "center", paddingInline: "6px", borderRadius: "5px", }}>
              <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: "10px", sm: "11px" }, color: "#A4A4A4", }}>
                {toPersianNumber(`${lastDate}`)}
              </TypoGraphyKit>
            </BoxKit>
          </StackKit>
        </Grid>

        {/* Chart Section */}
        <Grid size={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center",padding:0 }}>
          <DonutChart seriesData={series} labelsData={labels} />
        </Grid>
      </Grid>
    </CardKit>

  );
};

export default TotalSales;
